import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { setModal } from '../../reducers/UiReducer';
import CloseIcon from '@mui/icons-material/Close';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 400,
	bgcolor: 'background.paper',
	border: '2px solid #000',
	boxShadow: 24,
	p: 4,
};

export default function CoupanModal() {
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const dispatch = useDispatch();
	const { modal } = useSelector((state) => state.ui);
	const handleClose = () => {
		dispatch(setModal(false));
	};
	return (
		<div>
			<Modal
				open={modal}
				onClose={handleClose}
				aria-labelledby='modal-modal-title'
				aria-describedby='modal-modal-description'>
				<Box sx={style}>
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id='modal-modal-title' variant='h6' component='h1'>
							Add coupon code
						</Typography>
						<CloseIcon
							style={{ cursor: 'pointer' }}
							onClick={() => dispatch(setModal(false))}
						/>
					</Box>
					<Box sx={{ mt: 2 }}>
						<input style={{ width: '93%', padding: 12 }} />
					</Box>
					<Button
						style={{
							background: 'orangered',
							color: 'white',
							width: '100%',
							marginTop: 20,
						}}>
						Apply
					</Button>
				</Box>
			</Modal>
		</div>
	);
}
